import { Component, ViewChild, inject } from '@angular/core';
import { CommonModule, NgClass } from '@angular/common';
import {
    DxButtonComponent,
    DxDataGridComponent,
    DxDataGridModule,
    DxFormComponent,
    DxFormModule,
    DxTemplateDirective,
} from 'devextreme-angular';
import { CustomerStatus, CustomerGridViewDto, AuthService, PermissionType, AccessType } from '@services';
import EnumUtils from '../../../shared/enum-utils';
import { FilterPanelComponent } from '../../../components/library/filter-panel/filter-panel.component';
import { PhoneFormatPipe } from 'src/app/pipes/phone-format.pipe';
import { CapitalCasePipe } from '../../../pipes/capital-case.pipe';
import {
    FilterConfig,
    GridPageComponent,
} from '../../common/grid-page.component';
import { DATE_TIME_FORMAT } from 'src/app/shared/constants';
import { UserAvatarEmailComponent } from 'src/app/components/utils/user-avatar-email/user-avatar-email.component';

@Component({
    selector: 'app-customers',
    imports: [
        CommonModule,
        CapitalCasePipe,
        DxDataGridComponent,
        DxDataGridModule,
        DxButtonComponent,
        DxTemplateDirective,
        DxFormComponent,
        DxFormModule,
        FilterPanelComponent,
        PhoneFormatPipe,
        NgClass,
        UserAvatarEmailComponent,
    ],
    templateUrl: './customers.component.html',
})
export class CustomersComponent extends GridPageComponent<CustomerGridViewDto> {
    @ViewChild(DxDataGridComponent, {static: false}) grid!: DxDataGridComponent;

    private authService = inject(AuthService);
    protected override exportName: string = 'Customers';
    protected offset: number = 100;
    public dateTimeFormat = DATE_TIME_FORMAT;

    dataSource = this.dataSources.customers();
    customerStatusOptions = EnumUtils.getEnumOptions(CustomerStatus);

    canManage = this.authService.checkPermission(PermissionType.Customers, AccessType.Manage);

    protected override filterConfig: FilterConfig[] = [
        { field: 'number', op: 'contains' },
        { field: 'name', op: 'contains' },
        { field: 'address', op: 'contains' },
        { field: 'email', op: 'contains' },
        { field: 'phone', op: 'contains' },
        { field: 'status', op: '=' },
        {field: 'lastModified', op: '>='},
    ];

    constructor() {
        super();
        this.init(CustomerGridViewDto);
    }

    protected getBadgeClass(status: CustomerStatus): string {
        switch (status) {
            case CustomerStatus.Inactive:
                return 'bg-secondary-subtle text-secondary';
            case CustomerStatus.Active:
                return 'bg-success-subtle text-success';
            default:
                return 'bg-info-subtle text-info';
        }
    }

    addNew() {
        this.grid.instance.addRow();
    }

    onInitNewRow = (e: any) => {
        e.data.status = CustomerStatus.Active;
    };

    onRowUpdating(e: any) {
        e.newData = Object.assign({}, e.oldData, e.newData);
    }

    onRowDblClick(e: any) {
        if (e.rowType === 'data' && this.canManage) {
            e.component.editRow(e.rowIndex);
        }
    }

    // The Customer ID is the immutable unique identifier: editable only while adding a new row.
    onEditorPreparing = (e: any) => {
        if (e.parentType === 'dataRow' && e.dataField === this.gridFieldName('number') && !e.row?.isNewRow) {
            e.editorOptions.readOnly = true;
        }
    };
}
